import {
  GlobalFilterRoute,
  GlobalFilterPathName,
} from '@/modules/ta/globalfilters/globalfilters.constants';
import { GlobalFilterRouteConfig } from '@/modules/ta/globalfilters/GlobalFilterRouteConfig';

export const router = GlobalFilterRouteConfig.factory([
  {
    path: `/${GlobalFilterRoute.GLOBAL_FILTERS}`,
    name: GlobalFilterPathName.GLOBAL_FILTERS,
    component: () =>
      import(/* webpackChunkName: "globalfilters-page" */ './pages/GlobalFiltersPage.vue'),
  },
  {
    path: `/${GlobalFilterRoute.GLOBAL_FILTERS}/new`,
    name: GlobalFilterPathName.GLOBAL_FILTERFORM_NEW,
    component: () =>
      import(/* webpackChunkName: "globalfilters-form-page" */ './pages/GlobalFilterFormPage.vue'),
  },
  {
    path: `/${GlobalFilterRoute.GLOBAL_FILTERS}/:id`,
    name: GlobalFilterPathName.GLOBAL_FILTERFORM,
    component: () =>
      import(/* webpackChunkName: "globalfilters-form-page" */ './pages/GlobalFilterFormPage.vue'),
  },
]);
